/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_TimingInputs */



/**
* | output |
* | --- |
* | "Timing" |
*
* @param {Event_Group_Sync_Property_TimingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_timing = /** @type {((inputs?: Event_Group_Sync_Property_TimingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_TimingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "es") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Timing")
	return /** @type {LocalizedString} */ ("Timing")
});